import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { addMixpanelTrackingEvent } from '../../services/CommonService'

const Menu = ({ onClose }) => {
    const [activeTab, setActiveTab] = useState('')
    const currentLocation = useLocation()
    const navigate = useNavigate()

    useEffect(() => {
        getNavActiveTab()
    }, [currentLocation.pathname])

    const getNavActiveTab = () => {
        let activeTab =
            currentLocation.pathname === '/design-lab'
                ? 'DESIGN_LAB'
                : currentLocation.pathname === '/dashboard'
                ? 'MY_DASHBOARD'
                : currentLocation.pathname === '/favourites'
                ? 'FAVOURITES'
                : ''
        setActiveTab(activeTab)
    }

    const setNavActiveTab = (tabName) => {
        setActiveTab(tabName)
    }

    return (
        <ul>
            <li
                className={
                    activeTab === 'DESIGN_LAB'
                        ? 'active cursor-pointer'
                        : 'cursor-pointer'
                }
                onClick={() => {
                    setNavActiveTab('DESIGN_LAB')
                    navigate('/design-lab')
                    addMixpanelTrackingEvent({}, 'BUYER_VIEW_DESIGN_LAB')
                    if (onClose) onClose()
                }}
            >
                Design Lab
            </li>
            <li
                className={
                    activeTab === 'MY_DASHBOARD'
                        ? 'active cursor-pointer'
                        : 'cursor-pointer'
                }
                onClick={() => {
                    setNavActiveTab('MY_DASHBOARD')
                    navigate('/dashboard?active=OVERVIEW')
                    addMixpanelTrackingEvent({}, 'BUYER_VIEW_DASHBOARD')
                    if (onClose) onClose()
                }}
            >
                My Dashboard
            </li>
            <li
                className={
                    activeTab === 'FAVOURITES'
                        ? 'active cursor-pointer ml-10'
                        : 'cursor-pointer ml-10'
                }
                onClick={() => {
                    setNavActiveTab('FAVOURITES')
                    navigate('/favourites')
                    addMixpanelTrackingEvent({}, 'PAGE_VISITED')
                    if (onClose) onClose()
                }}
            >
                My Folders
            </li>
        </ul>
    )
}

export default Menu
